import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2'
import colors from 'vuetify/lib/util/colors'

Vue.use(VueSweetalert2, {
  reverseButtons: true,
  confirmButtonColor: colors.green.darken1,
})
